import React, {
  useEffect,
} from "react";

import {
  useNavigate,
  useParams,
} from "react-router-dom";

import QueryDetails
  from "../components/QueryDetails";

import {
  useQueries,
} from "../hooks/useQueries";


const QueryDetailsPage = () => {

  const {
    id,
  } = useParams();

  const navigate =
    useNavigate();


  const {
    query,
    detailsLoading,
    saving,
    deleting,
    error,

    fetchQuery,
    updateQuery,
    deleteQuery,
  } = useQueries();


  useEffect(() => {

    if (id) {
      fetchQuery(id);
    }

  }, [
    id,
    fetchQuery,
  ]);


  const handleUpdate = async (
    queryId,
    data
  ) => {

    try {

      await updateQuery(
        queryId,
        data
      );

    } catch (error) {
      // Hook already stores the error.
    }
  };


  const handleDelete = async (
    queryId
  ) => {

    const confirmed =
      window.confirm(
        "Are you sure you want to delete this query?"
      );


    if (!confirmed) {
      return;
    }


    try {

      await deleteQuery(
        queryId
      );

      navigate(
        "/dashboard/queries"
      );

    } catch (error) {
      // Hook handles error state.
    }
  };


  if (detailsLoading) {

    return (
      <div className="query-details-page-state">
        Loading query...
      </div>
    );

  }


  return (
    <div className="query-details-page">

      <div className="query-details-page-header">

        <button
          type="button"
          className="query-back-button"
          onClick={() =>
            navigate(
              "/dashboard/queries"
            )
          }
        >
          ← Back to Queries
        </button>

      </div>


      {error && (
        <div className="query-error-message">
          {error}
        </div>
      )}


      <QueryDetails
        query={query}
        saving={saving}
        deleting={deleting}
        onUpdate={handleUpdate}
        onDelete={handleDelete}
      />

    </div>
  );
};


export default QueryDetailsPage;